import React, { useState } from 'react';
import { ValidatedAIResponse } from '../../../ai/responseSchema';

export function ScenarioFramework({ thesis }: { thesis: ValidatedAIResponse }) {
  const [open, setOpen] = useState(false);
  const bias      = thesis.overallBias;
  const baseProb  = thesis.conviction >= 70 ? 'HIGH' : thesis.conviction >= 50 ? 'MED' : 'LOW';
  const altProb   = thesis.conviction >= 70 ? 'LOW'  : thesis.conviction >= 50 ? 'MED' : 'HIGH';
  const bearColor = 'var(--red)', bullColor = 'var(--green)';
  const baseColor = bias === 'bullish' ? bullColor : bias === 'bearish' ? bearColor : 'var(--amber)';

  const scenarios = [
    { label: 'BASE CASE',          color: baseColor,                                  prob: baseProb, thesis: thesis.primaryThesis,                              trigger: thesis.confirmationNeeded, target: thesis.targetLogic                },
    { label: bias === 'bullish' ? 'BEAR SCENARIO' : 'BULL SCENARIO', color: bias === 'bullish' ? bearColor : bullColor, prob: altProb,   thesis: `Thesis fails if ${thesis.invalidation}. ${thesis.primaryRisk}.`, trigger: thesis.invalidation,       target: `Risk: ${thesis.primaryRisk}` },
    { label: 'INVALIDATION PATH',  color: 'var(--blue-dim)',                          prob: '—',      thesis: thesis.invalidation,                               trigger: 'See invalidation level',  target: 'Exit / reassess immediately'     },
  ];

  return (
    <div style={{ marginTop: 12 }}>
      <button onClick={() => setOpen(!open)}
        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0,
          display: 'flex', alignItems: 'center', gap: 6, marginBottom: open ? 8 : 0 }}>
        <span style={{ fontSize: 9, fontFamily: 'var(--mono)', fontWeight: 700,
          color: 'var(--blue-dim)', letterSpacing: '1.5px' }}>
          {open ? '▾' : '▸'} SCENARIO FRAMEWORK
        </span>
        <span style={{ fontSize: 8, color: 'var(--blue-dim)', fontFamily: 'var(--mono)' }}>
          ({scenarios.length} paths)
        </span>
      </button>
      {open && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {scenarios.map(s => (
            <div key={s.label} style={{ borderLeft: `2px solid ${s.color}`, padding: '6px 10px',
              background: `${s.color}08`, borderRadius: '0 4px 4px 0' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
                <span style={{ fontSize: 8, fontWeight: 700, fontFamily: 'var(--mono)',
                  color: s.color, letterSpacing: '1px' }}>{s.label}</span>
                <span style={{ fontSize: 7, fontFamily: 'var(--mono)', color: s.color,
                  border: `1px solid ${s.color}44`, padding: '0 4px', borderRadius: 2 }}>prob: {s.prob}</span>
              </div>
              <p style={{ fontSize: 11, color: 'var(--t1)', margin: '0 0 4px 0', lineHeight: 1.5 }}>{s.thesis}</p>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 4 }}>
                <div>
                  <div style={{ fontSize: 7, color: 'var(--t3)', fontFamily: 'var(--mono)', marginBottom: 1 }}>CONFIRMS IF</div>
                  <div style={{ fontSize: 10, color: 'var(--amber)', lineHeight: 1.4 }}>{s.trigger}</div>
                </div>
                <div>
                  <div style={{ fontSize: 7, color: 'var(--t3)', fontFamily: 'var(--mono)', marginBottom: 1 }}>OUTCOME</div>
                  <div style={{ fontSize: 10, color: s.color, lineHeight: 1.4 }}>{s.target}</div>
                </div>
              </div>
            </div>
          ))}
          <div style={{ fontSize: 9, color: 'var(--blue-dim)', fontFamily: 'var(--mono)', marginTop: 2 }}>
            Scenarios derived from AI thesis — base case reflects current conviction ({thesis.conviction}%)
          </div>
        </div>
      )}
    </div>
  );
}
